// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"9c1693a3","773":"db863cc3","910":"1cca2da4","988":"c52300f6"}[chunkId] + ".chunk.js";
};